import { useMemo } from 'react';

/**
 * Hook to check if the Bendix theme is currently active
 * @returns {boolean} true if Bendix theme is active, false otherwise
 */
export const useIsBendixTheme = () => {
  return useMemo(() => {
    if (typeof window === 'undefined') return false;

    const currentTheme = window.__litium?.currentTheme;
    return currentTheme?.toLowerCase() === 'bendix';
  }, []);
};

/**
 * Hook to check if the Apex theme is currently active
 * @returns {boolean} true if Apex theme is active, false otherwise
 */
export const useIsApexTheme = () => {
  return useMemo(() => {
    if (typeof window === 'undefined') return false;

    const currentTheme = window.__litium?.currentTheme;
    return currentTheme?.toLowerCase() === 'apex';
  }, []);
};
